import $ from 'jquery';
import 'jquery-match-height';
import { Component } from '../../../component';

export class PanelList extends Component {
	setup() {
		const $panelEl = $('.js-c-panel');
		if ( $panelEl.length ) {
			$panelEl.matchHeight( {
				byRow: false,
				property: 'height',
			} );
		}
	}
}
